function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,4.5h4.7c1.6,0,2.4,0.7,2.4,2c0,0.7-0.3,1.2-0.7,1.5c0.9,0.5,1.3,1.3,1.3,2.2c0,1.5-1,2.5-2.7,2.5H0V4.5z M4.8,7.7 c0.8,0,1.3-0.4,1.3-1.1c0-0.8-0.4-1.2-1.3-1.2H1v2.3H4.8z M5.2,11.8c0.9,0,1.5-0.6,1.5-1.5c0-0.9-0.5-1.5-1.5-1.5H1v3.1H5.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5,4.5h6.3v0.9h-5.3v2.4h3.2v0.9h-3.2v3h5.6v0.9h-6.6V4.5z M13.9,3.6L15.4,1h1.1l-1.9,2.6H13.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.4,4.5h4.7c1.6,0,2.4,0.7,2.4,2c0,0.7-0.3,1.2-0.7,1.5c0.9,0.5,1.3,1.3,1.3,2.2c0,1.5-1,2.5-2.7,2.5h-5V4.5z M26.2,7.7 c0.8,0,1.3-0.4,1.3-1.1c0-0.8-0.4-1.2-1.3-1.2h-3.8v2.3H26.2z M26.6,11.8c0.9,0,1.5-0.6,1.5-1.5c0-0.9-0.5-1.5-1.5-1.5h-4.2v3.1 H26.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6,4.5h0.8l3.9,8.2h-1.1l-1.1-2.2h-4.4l-1,2.2h-1.1L35.6,4.5z M37.8,9.6L36,5.9l-1.7,3.7H37.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43.4,4.5h6.3v0.9h-5.3v2.4h3.2v0.9h-3.2v3H50v0.9h-6.6V4.5z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 16.5",
    fill: "current",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.7a43f1f2.svg";
export { ForwardRef as ReactComponent };